module.exports = __webpack_public_path__ + "img/campaign-snapchat.e54dd653.svg";